import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  Action_GetCauHinhJS,
  Action_SaveLichSuView,
  Action_GetLichSuView
} from "actions/HeThongNT/actionTypes";
import {
  Index_GetCauHinhJSSuccess,
  Index_SaveLichSuViewSuccess,
  Index_GetLichSuViewSuccess
} from "actions/HeThongNT";
import hethongntApi from "service/HeThongNT/HeThongNTApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from 'utils/utils';

//Region api
function* Saga_getCauHinhJs(action) {
  try {
    const response = yield call(hethongntApi.getCauHinhJs, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetCauHinhJSSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_GetCauHinhJS() {
  yield takeLatest(Action_GetCauHinhJS, Saga_getCauHinhJs);
}
/////////////////////////////////
function* Saga_SaveLichSuView(action) {
  try {
    const response = yield call(hethongntApi.saveLichSuView, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_SaveLichSuViewSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_SaveLichSuView() {
  yield takeLatest(Action_SaveLichSuView, Saga_SaveLichSuView);
}
////////////////////////////////////
function* Saga_GetLichSuView(action) {
  try {
    const response = yield call(hethongntApi.getCauHinhJs, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetLichSuViewSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* watch_GetLichSuView() {
  yield takeLatest(Action_GetLichSuView, Saga_GetLichSuView);
}
//endregion watchAPI

export default function* sagas() {
  yield all([watch_GetCauHinhJS(), watch_SaveLichSuView(), watch_GetLichSuView()]);
}
